import React from 'react';
import { Modal } from 'react-bootstrap';
import { Input } from '../../../common/Forms/Input/Input';
import { useWatch } from 'react-hook-form';

export default function DiscountForm({
  isOpen,
  onClose,
  onSubmit,
  register,
  errors,
  editingDiscountId,
  setValue,
  control,
  clearErrorByFieldName,
  listActiveCodes = []
}) {
  const DISCOUNT_LANDING = {
    PUBLIC: 'Publica',
    INTERNAL: 'Privada',
    RENEWAL: 'Renewal',
    SELF_RENEWAL: 'selfRenewal',
  };

  const landingOptions = [
    { value: DISCOUNT_LANDING.PUBLIC, label: 'Afiliación nueva - Página web' },
    { value: DISCOUNT_LANDING.RENEWAL, label: 'Renovación - Landing interno' },
    { value: DISCOUNT_LANDING.INTERNAL, label: 'Afiliación nueva - Landing interno' },
    { value: DISCOUNT_LANDING.SELF_RENEWAL, label: 'Renovación - Página web' },
  ];


  const LANDING_DISCOUNT_CAMPAIGN_STATUS = {
    CREADA: 'Creada',
    ACTIVO: 'Activo',
    VENCIDO: 'Vencido',
    INACTIVO: 'Inactivo',
  }

  const dateFromWatch = useWatch({
    control,
    name: 'startDate'
  });


  const statusFromWatch = useWatch({
    control,
    name: 'status',
    defaultValue: LANDING_DISCOUNT_CAMPAIGN_STATUS.CREADA
  });

  const selectedLandings = useWatch({
    control,
    name: 'landings',
    defaultValue: [],
  });

  const handleLandingToggle = (landing) => {
    const updatedLandings = selectedLandings.includes(landing)
      ? selectedLandings.filter((item) => item !== landing)
      : [...selectedLandings, landing];

    setValue('landings', updatedLandings);
    clearErrorByFieldName('landings');
  };

  const closeForm = () => {
    onClose();
  };

  return (
    <Modal size="lg" centered show={isOpen} onHide={closeForm} className="surcharges-form-modal discount-campaign-modal">
      <Modal.Header closeButton className="border-bottom-0">
        <Modal.Title style={{ fontSize: '18px', fontWeight: '700', color: '#1a1f36' }}>
          {editingDiscountId ? 'Editar campaña de descuento' : 'Nueva campaña de descuento'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-3 pb-0 pl-1 pr-1">
        <form id="discount-form" className="discount-campaign-form" onSubmit={onSubmit}>
          <div className="discount-campaign-form__grid">
            <div>
              <Input
                bootstrap={'col-12'}
                label={'CÓDIGO DE DESCUENTO *'}
                type={'select'}
                options={listActiveCodes}
                name={'discountCode'}
                placeholder={'Seleccione'}
                register={register}
                errors={errors?.discountCode?.message}
                disabled={listActiveCodes.length === 0}
              />
            </div>
            <Input
              bootstrap={'col-12'}
              label={'Descripcion de la campaña *'}
              type={'text'}
              name={'description'}
              register={register}
              placeholder={'Ej: Campaña verano 2025'}
              errors={errors?.description?.message}
            />
          </div>

          {
              statusFromWatch !== LANDING_DISCOUNT_CAMPAIGN_STATUS.VENCIDO && statusFromWatch !== LANDING_DISCOUNT_CAMPAIGN_STATUS.INACTIVO && (
                <div className="discount-campaign-form__grid discount-campaign-form__grid--dates">
                  <Input
                    bootstrap={'col-12'}
                    label={'Fecha de inicio *'}
                    type={'date'}
                    name={'startDate'}
                    register={register}
                    errors={errors?.startDate?.message}
                    control={control}
                    minDate={new Date()}
                  />
                  <Input
                    bootstrap={'col-12'}
                    label={'Fecha de fin *'}
                    type={'date'}
                    name={'expirationDate'}
                    register={register}
                    errors={errors?.expirationDate?.message}
                    control={control}
                    minDate={dateFromWatch ? new Date(dateFromWatch) : new Date()}
                  />
                </div>
              )
          }

          <div className="discount-campaign-form__landings-section">
            <p className="discount-campaign-form__field-label mb-0">APLICA EN LANDING *</p>
            <p className="discount-campaign-form__hint mb-2">
              Selecciona uno o más landings donde este código estará disponible
            </p>

            <div className="discount-campaign-form__checkbox-list">
              {landingOptions.map((option) => (
                <label key={option.value} className="discount-campaign-form__checkbox-item">
                  <input
                    type="checkbox"
                    checked={selectedLandings.includes(option.value)}
                    onChange={() => handleLandingToggle(option.value)}
                  />
                  <span>{option.label}</span>
                </label>
              ))}
            </div>

            {errors?.landings?.message && (
              <p className="surcharges-form__error-message mb-1">{errors.landings.message}</p>
            )}

            {selectedLandings.length > 0 && (
              <>
                <p className="discount-campaign-form__selected-title">LANDINGS SELECCIONADOS</p>
                <div className="discount-campaign-form__chips">
                  {selectedLandings.map((landing) => (
                    <span key={landing} className="discount-campaign-form__chip">
                      {landingOptions.find((option) => option.value === landing)?.label}
                    </span>
                  ))}
                </div>
              </>
            )}
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="border-top-0 pt-0 pb-3 pl-3 pr-3">
        <div className="surcharges-form__modal-footer discount-campaign-form__footer">
          <div className="surcharges-form__footer-actions">
            <button type="button" className="surcharges-form__btn-cancel" onClick={closeForm}>Cancelar</button>
            <button type="submit" form="discount-form" className="surcharges-form__btn-submit">
              {editingDiscountId ? 'Guardar' : 'Crear campaña'}
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
